import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { fetchTemplateDetails, TemplateDetailsResponse } from "../api/endpoints/fetchTemplates";

export interface UseDocxFormTemplateDetailsParams {
  templateId: string;
  userEmail: string;
}

export interface DocxTemplateDetailsResult {
  fileId: string;
  json?: unknown;
}

export function useDocxFormTemplateDetails(
  { templateId, userEmail }: UseDocxFormTemplateDetailsParams,
  options?: Omit<
    UseQueryOptions<DocxTemplateDetailsResult, Error, DocxTemplateDetailsResult, readonly unknown[]>,
    "queryKey" | "queryFn" | "enabled"
  >
): UseQueryResult<DocxTemplateDetailsResult, Error> {
  return useQuery<DocxTemplateDetailsResult, Error, DocxTemplateDetailsResult, readonly unknown[]>({
    queryKey: ["docxTemplateDetails", templateId] as const,
    queryFn: async (): Promise<DocxTemplateDetailsResult> => {
      const response: TemplateDetailsResponse = await fetchTemplateDetails(String(templateId), userEmail);
      const { fileId } = response.data;
      let htmlContent = response.data.htmlContent;
      let parsedJson: unknown | undefined = undefined;
      
      // For DOCX, backend may return JSON string
      try {
        parsedJson = JSON.parse(htmlContent);
      } catch {
        // Not JSON; leave as-is
      }
      
      return { fileId, json: parsedJson ?? undefined };
    },
    enabled: Boolean(templateId),
    networkMode: 'always',  
    retry: false,
    staleTime: 0,
    gcTime: 5 * 60 * 1000,
    ...options,
  });
}
